"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({}, props, {
    viewBox: '8 8 14 14',
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.7391528,10.1171668 C19.4586375,9.91594039 19.0682059,9.98033487 18.8670768,10.2609997 L13.0192087,18.4190331 L11.0671416,16.4641569 C10.9092762,16.3061247 10.6791427,16.2443663 10.46343,16.3021456 C10.2477174,16.3599249 10.0791976,16.5284638 10.0213504,16.7442754 C9.96350315,16.9600869 10.0251169,17.1903841 10.1829823,17.3484163 L12.6558784,19.8223416 C12.7872113,19.9487926 12.9664896,20.0127255 13.1481477,19.9978908 C13.3298058,19.9830562 13.496351,19.8908825 13.6054539,19.744797 L19.8829016,10.9897529 C20.0840105,10.7090735 20.0196536,10.3184136 19.7391528,10.1171668 Z",
    fill: "currentColor"
  }));
});